import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-light-svg-icons/faClockRotateLeft';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { browseCreditMessages as messages } from '../browseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseRail.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowseRecentSearchesProps {
  items: string[];
  onPick: (query: string) => void;
  onClear: () => void;
}

/** Recent searches (design a1 rail), kept in this browser for the signed-in user. */
const BrowseRecentSearchesComponent: React.FC<BrowseRecentSearchesProps> = ({ items, onPick, onClear }) => {
  const intl = useIntl();
  if (items.length === 0) {
    return null;
  }
  return (
    <Panel as="section">
      <PanelHead
        title={intl.formatMessage(messages.recentTitle)}
        icon={<FontAwesomeIcon icon={faClockRotateLeft} />}
        right={
          <button type="button" className={styles.linkButton} onClick={onClear}>
            {intl.formatMessage(messages.recentClear)}
          </button>
        }
      />
      <PanelBody flush>
        <div className={styles.recentList}>
          {items.map((item) => (
            <button key={item} type="button" className={styles.recentItem} onClick={() => onPick(item)}>
              <FontAwesomeIcon icon={faClockRotateLeft} />
              {item}
            </button>
          ))}
        </div>
      </PanelBody>
    </Panel>
  );
};

export const BrowseRecentSearches = TypedMemo(BrowseRecentSearchesComponent);
